/** GraphQL Query that fetches customer addresses. */
export default `
  query getCustomerAddresses {
    customer {
      addresses {
        city
        country_code
        default_billing
        default_shipping
        extension_attributes {
          attribute_code
          value
        }
        custom_attributesV2(attributeCodes: [
          "company_email", "invoice_email"
        ]){
          code
          ... on AttributeValue {
            value
          }
        }
        firstname
        id
        lastname
        postcode
        prefix
        region {
          region_code
          region_id
          region
        }
        street
        suffix
        telephone
        vat_id
        company
      }
    }
  }
`;
